async function setOverseasToken() {
    if (window.name) {
        const _token = JSON.stringify({ v: { token: 'Bearer ' + window.name }, t: 0 });
        await localStorage.setItem('-authInfo', _token);
        window.name = ''
    }
}

export default setOverseasToken